<template>
  <div class="px-sm-4">
    <b-card body-class="p-md-1 p-0">
      <b-card-header class="align-items-start flex-sm-row flex-column-reverse">
        <b-card-title class="mt-sm-0 mt-2">
          <b-media class="align-items-center">
            <template #aside>
              <div
                v-if="logoPreview || logo"
                class="bg-dark d-flex justify-content-center align-items-center bg-secondary rounded-avatar"
                style="height: 100px"
              >
                <b-img
                  :src="logoPreview || logo || errorImage"
                  :alt="name"
                  width="100px"
                  style="max-height: 100px"
                  rounded
                  class="p-25"
                  @error="setAltImg"
                />
              </div>
              <b-avatar
                ref="previewEl"
                :alt="name"
                size="100px"
                rounded="lg"
                v-else
                class="bg-secondary text-muted rounded-avatar"
              >
              </b-avatar>
            </template>
            <h5 class="mb-1 text-white">
              {{
                $route.params.id
                  ? "Edit Partner"
                  : $route.name == "partners-edit-profile"
                  ? "Edit profile"
                  : "Create Partner"
              }}
            </h5>
            <div class="d-flex flex-wrap">
              <b-button class="gradient-btn" @click="$refs.previewlogo.click()">
                <input
                  @input="changeLogo"
                  ref="previewlogo"
                  type="file"
                  class="d-none"
                  accept="image/*"
                />
                <span class="d-none d-sm-inline">Upload</span>
                <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
              </b-button>
              <b-button
                class="ml-50 px-75"
                @click="removeLogo"
                :disabled="!logo"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </b-media>
        </b-card-title>

        <b-link
          :to="{
            name:
              $route.name == 'partners-edit-profile'
                ? 'partner-dashboard'
                : 'partners',
          }"
        >
          <span
            >back to the
            {{
              $route.name == "partners-edit-profile"
                ? "dashboard"
                : "Partner list"
            }}
          </span>
          <feather-icon icon="ChevronRightIcon"
        /></b-link>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="createForm">
          <b-form class="form mt-2" @submit.prevent="createForm">
            <b-row>
              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="full-name"
                  class="w-100"
                  label="Full name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Full name"
                    rules="required"
                  >
                    <b-form-input
                      id="Full-name"
                      v-model="name"
                      name="name"
                      placeholder="Johon Doe"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="user-name"
                  class="w-100"
                  label="User name"
                >
                  <validation-provider #default="{ errors }" name="User name">
                    <b-form-input
                      :disabled="
                        $route.name == 'partners-edit-profile' &&
                        userData.type !== 'admin'
                      "
                      id="username"
                      v-model="username"
                      name="name"
                      placeholder="Johon Doe"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group label-for="email" class="w-100" label="Email">
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    :rules="
                      $route.name == 'partners-edit-profile' &&
                      userData.type !== 'admin'
                        ? ''
                        : 'required|email'
                    "
                  >
                    <b-form-input
                      :disabled="
                        $route.name == 'partners-edit-profile' &&
                        userData.type !== 'admin'
                      "
                      id="email"
                      v-model="email"
                      name="email"
                      placeholder="johndoe@example.com"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group label-for="mobile" class="w-100" label="Mobile">
                  <validation-provider
                    #default="{ errors }"
                    name="Mobile"
                    :rules="
                      $route.name == 'partners-edit-profile' &&
                      userData.type !== 'admin'
                        ? ''
                        : 'phone'
                    "
                  >
                    <b-form-input
                      :disabled="
                        $route.name == 'partners-edit-profile' &&
                        userData.type !== 'admin'
                      "
                      id="mobile"
                      v-model="mobile"
                      name="mobile"
                      placeholder="+911234567890"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="nationality"
                  class="w-100"
                  label="nationality"
                >
                  <b-skeleton height="20px" v-if="loading" />
                  <select-box
                    v-else
                    v-model="nationality"
                    label="text"
                    class="w-100"
                    select="id"
                    searchable
                    url="country"
                  />
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="company_name"
                  class="w-100"
                  label="Company name"
                >
                  <b-form-input
                    id="company_name"
                    v-model="company_name"
                    name="company_name"
                  />
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <validation-provider
                  #default="{ errors }"
                  name="Website"
                  class="w-100"
                  rules="url"
                >
                  <b-form-group label-for="website" label="website">
                    <b-form-input
                      id="website"
                      v-model="website"
                      name="website"
                      placeholder="http://www.example.com"
                      :state="errors.length > 0 ? false : null"
                    />
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col class="d-flex" lg="4">
                <validation-provider
                  #default="{ errors }"
                  name="birthdate"
                  class="w-100"
                  rules="over18"
                >
                  <b-form-group
                    label-for="birthdate"
                    class="w-100"
                    label="Birth date"
                  >
                    <flat-pickr
                      @click.native="blurPicker"
                      id="birthdate"
                      v-model="birthdate"
                      class="form-control"
                      :config="{
                        enableTime: false,
                        dateFormat: 'Y-m-d',
                      }"
                      :state="errors.length > 0 ? false : null"
                    />
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="business_scale"
                  class="w-100"
                  label="Business scale"
                >
                  <v-select
                    :options="businessScales"
                    v-model="business_scale"
                    :searchable="false"
                    label="scale"
                    :reduce="(option) => option.value"
                  ></v-select>
                </b-form-group>
              </b-col>

              <b-col class="d-flex mr-lg-2" lg="4">
                <b-form-group
                  label-for="audience"
                  class="w-100"
                  label="Audience"
                >
                  <b-form-input
                    id="audience"
                    v-model="audience"
                    name="audience"
                    type="number"
                    min="1"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="8">
                <div class="d-flex flex-wrap">
                  <h4 class="col-md-12 px-0 mb-1">Socials</h4>
                  <div class="col-md-6 pr-md-1 px-0 pb-2">
                    <b-input-group prepend="@instagram">
                      <b-form-input
                        id="instagram"
                        v-model="socials.instagram"
                        name="instagram"
                      />
                    </b-input-group>
                  </div>
                  <div class="col-md-6 pl-md-1 px-0 pb-2">
                    <b-input-group prepend="@telegram">
                      <b-form-input
                        id="telegram"
                        v-model="socials.telegram"
                        name="telegram"
                      />
                    </b-input-group>
                  </div>
                  <div class="col-md-6 pr-md-1 px-0 pb-2">
                    <b-input-group prepend="@twitter">
                      <b-form-input
                        id="twitter"
                        v-model="socials.twitter"
                        name="twitter"
                      />
                    </b-input-group>
                  </div>
                  <div class="col-md-6 pl-md-1 pb-2 px-0">
                    <b-input-group prepend="@youtube">
                      <b-form-input
                        id="youtube"
                        v-model="socials.youtube"
                        name="youtube"
                      />
                    </b-input-group>
                  </div>
                  <div class="col-md-6 pr-md-1 px-0 pb-2">
                    <b-input-group prepend="@facebook">
                      <b-form-input
                        id="facebook"
                        v-model="socials.facebook"
                        name="facebook"
                      />
                    </b-input-group>
                  </div>
                  <div class="col-md-6 pl-md-1 pb-2 px-0">
                    <b-input-group prepend="@linkedin">
                      <b-form-input
                        id="linkedin"
                        v-model="socials.linkedin"
                        name="linkedin"
                      />
                    </b-input-group>
                  </div>
                </div>
              </b-col>
              <b-col class="d-flex flex-column mb-2 px-1" lg="4">
                <b-form-group
                  class="w-100 position-relative"
                  label="Upload cover"
                >
                  <div
                    v-if="coverPreview || cover"
                    class="d-flex align-items-center justify-content-center py-3"
                  >
                    <b-img
                      ref="previewEl"
                      :src="coverPreview || cover || errorImage"
                      :alt="name"
                      rounded
                      fluid
                      class="p-25"
                      @error="setAltImg"
                    />
                  </div>
                  <b-avatar
                    ref="previewEl"
                    :alt="name"
                    style="height: 140px; width: 100%"
                    rounded
                    class="bg-secondary text-muted"
                    v-else
                  >
                    <feather-icon icon="ImageIcon" size="60" class="mb-3" />
                  </b-avatar>
                  <div
                    class="d-flex w-100 justify-content-center banner-btns flex-wrap my-2"
                  >
                    <b-button
                      :class="[
                        coverPreview || cover
                          ? 'gradient-btn px-75'
                          : ' px-75 border',
                      ]"
                      @click="$refs.refInputEl.click()"
                    >
                      <input
                        @input="changeCover"
                        ref="refInputEl"
                        type="file"
                        class="d-none"
                        accept="image/*"
                      />
                      <span class="d-none d-sm-inline">Upload</span>
                      <feather-icon
                        icon="EditIcon"
                        class="d-inline d-sm-none"
                      />
                    </b-button>
                    <b-button
                      class="ml-50 px-75 border"
                      @click="removeCover"
                      :disabled="!cover"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <div
              class="d-flex align-items-center flex-wrap justify-content-end"
            >
              <b-button class="mt-sm-0 mt-50 mr-50 gradient-btn" type="submit">
                submit
              </b-button>
              <b-button
                v-if="$store.state.auth.userData.type !== 'admin'"
                variant="primary"
                class="mt-sm-0 mt-50"
                @click="showChangePassword = true"
                >Change password</b-button
              >
            </div>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <loader :loading="loading" />
    <b-modal v-model="showChangePassword" centered hide-footer>
      <change-password @closeShowChangePassword="showChangePassword = false" />
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BLink,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BFormTextarea,
  BMedia,
  BAvatar,
  BImg,
  BModal,
  BSkeleton,
} from "bootstrap-vue";
import { required, email, phone, url } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import ChangePassword from "./ChangePassword.vue";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    Loader,
    SelectBox,
    BFormTextarea,
    BMedia,
    BAvatar,
    BImg,
    BModal,
    ChangePassword,
    flatPickr,
    BSkeleton,
    vSelect,
  },
  data() {
    return {
      showChangePassword: false,
      name: "",
      username: "",
      email: "",
      logo: "",
      cover: "",
      mobile: "",
      nationality: "",
      company_name: "",
      website: "",
      birthdate: "",
      business_scale: "",
      audience: "",
      socials: {
        instagram: "",
        telegram: "",
        youtube: "",
        twitter: "",
        facebook: "",
        linkedin: "",
      },
      businessScales: [
        {
          value: 10,
          scale: "0-10 employee",
        },
        {
          value: 50,
          scale: "10-50 employee",
        },
        {
          value: 500,
          scale: "50-500 employee",
        },
        {
          value: 1000,
          scale: "500-1000 employee",
        },
      ],
      logoPreview: "",
      coverPreview: "",
      loading: false,
      userData: JSON.parse(localStorage.getItem("userData")),
      // validation rules
      required,
      email,
      phone,
      url,
    };
  },
  // created() {
  //   if (this.$route.params.id || this.$route.name == "partners-edit-profile") {
  //     this.getPartner();
  //   }
  // },
  watch: {
    $route: {
      handler(val) {
        if (val.params.id || val.name == "partners-edit-profile") {
          this.getPartner();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async removeCover() {
      this.loading = true;
      if (
        this.$route.params.id ||
        this.$route.name == "partners-edit-profile"
      ) {
        try {
          await this.$http.delete(
            this.$route.params.id
              ? `panel/partners/${this.$route.params.id}/cover`
              : `panel/profile/partner/cover`
          );
          await this.getPartner();
        } catch (err) {}
      } else {
        this.cover = "";
        this.coverPreview = "";
        this.$refs.refInputEl.value = "";
      }
      this.loading = false;
    },
    async removeLogo() {
      this.loading = true;
      if (
        this.$route.params.id ||
        this.$route.name == "partners-edit-profile"
      ) {
        try {
          await this.$http.delete(
            this.$route.params.id
              ? `panel/partners/${this.$route.params.id}/logo`
              : `panel/profile/partner/logo`
          );
          await this.getPartner();
        } catch (err) {}
      } else {
        this.logo = "";
        this.logoPreview = "";
        this.$refs.previewlogo.value = "";
      }
      this.loading = false;
    },
    async changeCover(e) {
      this.loading = true;
      if (
        this.$route.params.id ||
        this.$route.name == "partners-edit-profile"
      ) {
        try {
          let formData = new FormData();
          formData.append("cover", e.target.files[0]);
          const { data } = await this.$http.post(
            this.$route.params.id
              ? `panel/partners/${this.$route.params.id}/cover?_method=patch`
              : `panel/profile/partner/cover?_method=patch`,

            formData
          );
          this.$refs.refInputEl.value = "";
          await this.getPartner();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$route.params.id
                ? `Partner cover updated`
                : `Profile cover updated`,
              icon: "CoffeeIcon",
              variant: "success",
            },
          });
        } catch (err) {}
      } else {
        this.cover = e.target.files[0];
        this.coverPreview = URL.createObjectURL(this.cover);
      }
      this.loading = false;
    },
    async changeLogo(e) {
      this.loading = true;
      if (
        this.$route.params.id ||
        this.$route.name == "partners-edit-profile"
      ) {
        try {
          let formData = new FormData();
          formData.append("logo", e.target.files[0]);
          const { data } = await this.$http.post(
            this.$route.params.id
              ? `panel/partners/${this.$route.params.id}/logo?_method=patch`
              : `panel/profile/partner/logo?_method=patch`,
            formData
          );
          this.$refs.previewlogo.value = "";
          await this.getPartner();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$route.params.id
                ? `Partner logo updated`
                : `Profile logo updated`,
              icon: "CoffeeIcon",
              variant: "success",
            },
          });
        } catch (err) {}
      } else {
        this.logo = e.target.files[0];
        this.logoPreview = URL.createObjectURL(this.logo);
      }
      this.loading = false;
    },
    async getPartner() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          this.$route.params.id
            ? `/panel/partners/${this.$route.params.id}`
            : `/panel/profile/partner`
        );
        await Object.keys(
          this.$route.params.id ? data.data : data.partner.data
        ).map((item) => {
          if (item == "socials") {
            Object.keys(this.socials).map((social) => {
              this.socials[social] = this.$route.params.id
                ? data.data.socials[social]
                : data.partner.data.socials[social];
            });
          } else {
            this[item] = this.$route.params.id
              ? data.data[item]
              : data.partner.data[item];
          }
        });
        if (this.$route.name == "partners-edit-profile") {
          await localStorage.setItem(
            "userData",
            JSON.stringify({
              ...data.partner.data,
              documents: data.documents.data,
              type: "partner",
            })
          );
          await this.$store.dispatch("auth/setUserData", {
            ...data.partner.data,
            documents: data.documents.data,
            type: "partner",
          });
        }
      } catch (err) {}
      this.loading = false;
    },
    createForm() {
      this.$refs.createForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            this.formData = await new FormData();
            let newObject = await {
              name: this.name,
              username: this.username,
              email: this.email.toLowerCase(),
              mobile: this.mobile,
              nationality: this.nationality,
              company_name: this.company_name,
              website: this.website,
              birthdate: this.birthdate,
              business_scale: this.business_scale,
              audience: this.audience,
              socials: this.socials,
            };

            await Object.keys(newObject).map((item, index) => {
              this.setFormData(newObject[item], index, item);
            });

            if (
              this.$route.params.id ||
              this.$route.name == "partners-edit-profile"
            ) {
              const { data } = await this.$http.post(
                this.$route.params.id
                  ? `panel/partners/${this.$route.params.id}?_method=put`
                  : `/panel/profile/partner?_method=put`,
                this.formData
              );
              await this.getPartner();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$route.params.id
                    ? `Partner updated`
                    : `Profile updated`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              });
            } else {
              const { data } = await this.$http.post(
                "panel/partners",
                this.formData
              );
              if (this.$store.state.auth.userData.type == "admin") {
                this.$router.push({ name: "partners" });
              } else {
                this.$router.push({ name: "partner-dashboard" });
              }
            }
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
